import React from 'react';

export default function UploadCloudIcon(props) {
  const { color } = props;
  
  return (
    <svg width="33px" height="26px" viewBox="0 0 33 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <defs></defs>
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="Icon/Upload-AO-Blue" transform="translate(1.000000, 1.000000)">
              <g id="Group-4">
                  <path d="M22.9754423,24 L7.7034585,24 C3.45919633,24 0,20.5515789 0,16.32 C0,12.5178947 2.83359699,9.28421053 6.5381264,8.72842105 C6.5381264,3.91578947 10.4879889,0 15.3333171,0 C20.1786453,0 24.1285077,3.91578947 24.1285077,8.72842105 L24.1285077,8.72842105 C27.8453038,9.28421053 30.6666341,12.5052632 30.6666341,16.3073684 C30.6789008,20.5515789 27.2197045,24 22.9754423,24 Z" id="Download_Cloud-path" stroke={color || '#184E78'}></path>
                  <path d="M14.6544343,20 C14.4954128,20 14.3363914,19.9368421 14.2262997,19.8105263 L9.33333333,14.7578947 L10.2018349,13.8610526 L14.0550459,17.84 L14.0550459,8 L15.2782875,8 L15.2782875,17.84 L19.1314985,13.8610526 L20,14.7578947 L15.1070336,19.8105263 C14.9724771,19.9368421 14.8134557,20 14.6544343,20 Z" id="Download_Cloud-path" fill={color || '#184E78'} transform="translate(14.666667, 14.000000) scale(1, -1) translate(-14.666667, -14.000000) "></path>
              </g>
          </g>
      </g>
    </svg>
  );
}




// WEBPACK FOOTER //
// ./src/components/Iconoclast/UploadCloudIcon/index.js